import { useGetCompaniesQuery } from "api/public";
import useSessionStorage from "hooks/useSessionStorage";
import { useMemo } from "react";

export function useRecentlyCreatedCompanies({ pageSize = 5 }) {
  const [storedValue, setStoredValue] = useSessionStorage<string[]>(
    "createdCompanies",
    []
  );

  const createdCompaniesSearchQuery = useMemo(
    () =>
      storedValue
        .slice()
        .reverse()
        .map((id) => `id=${id}`)
        .join("||"),
    [storedValue]
  );

  const [response, refetch] = useGetCompaniesQuery({
    queryParams: {
      page: 1,
      pageSize,
      orderBy: "-created",
      query: createdCompaniesSearchQuery,
    },
  });

  return {
    ...response,
    refetch,
    storedValue,
    setStoredValue,
  };
}
